import React, { Component } from 'react';
import '../css/Tenemos.css'

class Tenemos extends Component {
  render() {
    return (
      <div id='panel-tenemos'>
        <h1 className="titulo-tenemos">¡Tenemos lo que necesitas!</h1>
        <hr className="barra"></hr>
        <div className="caja1-tenemos">
          <div className="panel panel-primary" id="panelprimary-tenemos">
            <div className="panel-heading" id="panelheading-tenemos">
              <h3 className="panel-title">Software Administrativo Contable</h3>
            </div>
            <div className="panel-body" id="panelbody-tenemos">
              El Software Contable es ideal para tener el control de inventarios,
               cuentas por cobrar, cuentas por pagar,etc.
            </div>
          </div>
          <div className="panel panel-primary" id="panel-primari-tenemos1">
            <div className="panel-heading" id="panel-heading-tenemos1">
              <h3 className="panel-title">Software de Produccion</h3>
            </div>
            <div class="panel-body" id="body-tenemos1">
              El Software de Produccion es  ideal para todo tipo de empresas
              que necesiten controlar su proceso productivo.
                    </div>
          </div>
          <div className="panel panel-primary" id="panel-primari-tenemos2" >
            <div className="panel-heading" id="panel-heading-tenemos2">
              <h3 className="panel-title"> Estadísticas de Ventas</h3>
            </div>
            <div className="panel-body" id="body-tenemos2">
              En esta sección usted podrá consultar información de las
              ventas mensuales y anuales por producto.
                    </div>
          </div>
        </div>
        <div className="panel-caja1">
          <div className="panel panel-primary" id="panel-primari-tenemos3">
            <div className="panel-heading" id="panel-heading-tenemos3">
              <h3 className="panel-title">Comercialización</h3>
            </div>
            <div className="panel-body" id="body-tenemos3">
              El proceso comercial nace desde las Compras
              almacenadas hasta el despacho final.
                </div>
          </div>
          <div className="panel panel-primary" id="panel-primari-tenemos4">
            <div className="panel-heading" id="panel-heading-tenemos4">
              <h3 className="panel-title">Contabilidad</h3>
            </div>
            <div className="panel-body" id="body-tenemos4">
              Centralización de la información de los
              diversos módulos a contabilidad ,escalabilidad.
                </div>
          </div>
          <div className="panel panel-primary" id="panel-primari-tenemos5" >
            <div className="panel-heading" id="panel-heading-tenemos5">
              <h3 className="panel-title">Logistica y Compras </h3>
            </div>
            <div className="panel-body" id="body-tenemos5">
              Manejo ordenado de la Gestión de compras y servicio.
                </div>
          </div>
        </div>
        <a id='empesar-tenemos' className="btn btn-primary" href="#id-experiencia">
          <p className="parrafo-empesar">Empezar</p></a>
      </div>
    );
  }


}

export default Tenemos;


// WEBPACK FOOTER //
// ./src/components/Tenemos.jsx